
import { ref, SetupContext } from "vue";

export interface OptionsI {
  id: string;
  label: string;
}

interface Props {
  options: OptionsI[];
  modelValue: OptionsI;
}

export default {
  name: "SelectDropdown",
  props: {
    options: Array as () => OptionsI[],
    modelValue: {
      type: Object as () => OptionsI,
      required: true,
      default: {},
    },
  },
  setup(props: Props, { emit }: SetupContext) {
    // Is the option window open
    const isOpen = ref(false);

    // Close the option window
    const closeDropdown = () => (isOpen.value = false);

    // Toggle the window
    const toggleDropdown = () => (isOpen.value = !isOpen.value);

    // Check if the option is selected or not
    const isSelected = (optionId: string) => {
      return props.modelValue.id === optionId;
    };

    // Handle Item's selection
    const onSelectValue = (value: OptionsI) => {
      emit("value-select", value);
      closeDropdown();
    };

    return {
      isOpen,
      isSelected,
      closeDropdown,
      toggleDropdown,
      onSelectValue,
    };
  },
  emits: ["value-select"],
};
